// extracted by mini-css-extract-plugin
module.exports = {"blogs-page":"style_blogs-page__ND5r9"};